import * as React from 'react';
import { useHistory } from "react-router-dom";

import PartnerCheckout from './PartnerCheckout';
import { ImpactPartner } from "../../models/ImpactPartner";
import { ShoppingCartItem } from '../../models/ShoppingCart';
import * as PartnerCheckoutStore from '../../store/PartnerCheckout';
import { PartnerMessage } from '../../models/PartnerMessage';

interface CheckoutPartnerProps {
    cartId: string;
    cartName: string;
    partner: ImpactPartner;
    currentImpactPartner: ImpactPartner;
    partnersMessages?: PartnerMessage[];
    cartItems: ShoppingCartItem[];
    partnerCheckout: PartnerCheckoutStore.IState;
    partnerCheckoutActions: typeof PartnerCheckoutStore.actionCreators;
    nextPartner?: ImpactPartner;
    sendingOrderResponse: boolean;
    onNext: () => void;
    onSendSummaryOrderResponse: () => void;
}

const CheckoutPartnerStep: React.FC<CheckoutPartnerProps> = ({
    cartId, cartName, partner, currentImpactPartner, partnersMessages, cartItems,
    partnerCheckout, partnerCheckoutActions, sendingOrderResponse,
    onNext, onSendSummaryOrderResponse, nextPartner }) => {

    const history = useHistory();

    const handleNext = () => {
        partnerCheckoutActions.resetCurrentStepState();
        onNext();
    };

    const continueShopping = () => {
        partnerCheckoutActions.resetState();
        history.push("/");
    };

    return (
        <>
            <PartnerCheckout
                cartId={cartId}
                cartName={cartName}
                partner={partner}
                cartItems={cartItems}
                currentImpactPartner={currentImpactPartner}
                partnersMessages={partnersMessages}
                partnerCheckoutState={partnerCheckout}
                partnerCheckoutActions={partnerCheckoutActions}
                nextPartner={nextPartner}
                onNext={handleNext}
                onContinueShopping={continueShopping}
                onSendOrderResponse={onSendSummaryOrderResponse}
                sendingOrderResponse={sendingOrderResponse}
            >
            </PartnerCheckout>
        </>
    );
};

export default CheckoutPartnerStep;